import { TYPES } from "./payout_status.type";

const INITIAL_STATE = {
  records: [],
  loading: false,
};

const payoutStatusReducer = (state = INITIAL_STATE, action) => {
  const { type, payload } = action;
  switch (type) {
    case TYPES.GET_PAYOUT_STATUS_REQUEST:
      return { ...state, loading: true };
    case TYPES.GET_PAYOUT_STATUS_SUCCESS:
      return { ...state, loading: false, records: payload };
    default:
      return state;
  }
};

export default payoutStatusReducer;
